'use client';

import { formatDateInputValue } from '@/utils/helpers';
import { Calendar, IconButton, Status } from '@yaradigitallabs/ahua-react';
import type React from 'react';

type DateFilterProps = {
  selectedDate: string;
  maxDate: string;
  isNextDateDisabled: boolean;
  onDateChange: (value: string) => void;
  onPreviousDate: () => void;
  onNextDate: () => void;
};

const DateFilter: React.FC<DateFilterProps> = ({
  selectedDate,
  maxDate,
  isNextDateDisabled,
  onDateChange,
  onPreviousDate,
  onNextDate,
}) => {
  return (
    <div className="px-8 py-2 flex flex-col md:flex-row gap-4 justify-start items-center">
      <div className="flex justify-start items-center gap-4">
        <IconButton
          colorConcept="brand"
          icon="ArrowLeft"
          title="Previous Date"
          size="s"
          onClick={onPreviousDate}
        />
        <div className="[&_label]:hidden! [&_input]:h-[40px]! [&_input]:pb-[11px]!">
          <Calendar
            type="dialog"
            mode="single"
            disableFuture
            firstWeekDay={1}
            startDate={new Date(selectedDate)}
            disabledDates={[new Date(maxDate)]}
            onChange={({ startDate }) => {
              onDateChange(formatDateInputValue(startDate));
            }}
          >
            <Calendar.Middle>
              <Calendar.WeekdayHeader />
              <Calendar.Body />
            </Calendar.Middle>
          </Calendar>
        </div>
        <IconButton
          colorConcept="brand"
          icon="ArrowRight"
          title="Next Date"
          size="s"
          disabled={isNextDateDisabled}
          onClick={onNextDate}
        />
      </div>
      <Status
        colorType="blue"
        iconLeading="Bangcircle"
        size="n"
        className="col-span-3! md:col-span-1! [&>label]:font-normal!"
      >
        By default, yesterday&apos;s date is pre-selected
      </Status>
    </div>
  );
};

export default DateFilter;
